/**
 * Admin Operations Metrics API Service
 */

import { apiClient } from "./apiClient";

export interface StreamMetrics {
  stream_type: string;
  stream_length: number;
  pending_count: number;
  consumer_lag: number;
  success_rate: number | null;
  fail_rate: number | null;
}

export interface RedisHealthStatus {
  status: string;
  circuit_breaker_state: string;
  circuit_breaker_failures: number;
  last_health_check: number | null;
  pool_stats: {
    redis_pools?: number;
    http_sessions?: number;
    db_pools?: number;
    is_running?: boolean;
  } | null;
}

export interface OpsMetricsResponse {
  timestamp: number;
  queue_metrics: Record<string, StreamMetrics>;
  entry_gate_metrics: Record<string, number>;
  reconciliation_metrics: {
    corrections_total: number;
  };
  orphan_metrics: {
    links_created_total: number;
    links_failed_total: number;
  };
  redis_health: RedisHealthStatus | null;
}

/**
 * Get operations metrics
 */
export async function getOpsMetrics(): Promise<OpsMetricsResponse> {
  const response = await apiClient.get<OpsMetricsResponse>(
    "/admin/ops/metrics",
    {
      timeout: 15000, // 15 second timeout to prevent hanging
    }
  );
  return response.data;
}

